import { m as e } from "./make-built-in.js";
import "./object-define-property.js";
import { __exports as t } from "../../../_virtual/object-define-property.js";
var r = function r(_r, o, s) {
  return s.get && e(s.get, o, {
    getter: !0
  }), s.set && e(s.set, o, {
    setter: !0
  }), t.f(_r, o, s);
};
export { r as d };